import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import IndustriesSection from "../components/IndustriesSection";
import WhySection from "../components/WhySection";
import ProjectsSection from "../components/ProjectsSection";
import ProcessTimeline from "../components/ProcessTimeline";
import ClientsSection from "../components/ClientsSection";
import TestimonialsSection from "../components/TestimonialsSection";
import ContactSection from "../components/ContactSection";

export default function HomePage() {
  return (
    <main data-testid="home-page" className="relative">
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <IndustriesSection />
      <WhySection />
      <ProjectsSection />
      <ProcessTimeline />
      <ClientsSection />
      <TestimonialsSection />
      <ContactSection />
    </main>
  );
}
